'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation showing an animated checkmark for success cases.
 */
export function CheckMarkSuccessAnimation(props: IAnimationProps) {
  const loadAnimation = () => import('./raw-json/success-checkmark.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="CheckMarkSuccessAnimation"
    />
  );
}
